import React, { useState } from 'react';
import { useNavigate } from "react-router";

// Material UI
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button"

// Components
import TitleSummary from './TitleSummary';
import PurchaseItems from './PurchaseItems';
import SelectPanel from './SelectPanel';
import InitiatePayment from './InitiatePayment';
import ReturnMode from './ReturnMode';
import Totals from './Totals'
import ModalConfirm from '../../../../components/modal/confirm';

// Modals
import CustomerModal from '../../../../components/customerModal';
import ShippingDataModal from '../../../../components/shippingModal';
import PaymentMethodModal from '../../../../components/paymentMethodModal';
import PromotionModal from '../promotions';
import InvoiceData from '../invoiceData';
import ObservationsOrder from '../observationOrder';
import SellerModal from '../seller';

//Hooks
import useStyles from './styles';
import useCart from '../../../../hooks/orders/CartProvider';
import useNotify from '../../../../hooks/notify';
import useChecks from "../../../../hooks/checks/useChecks";
import useCurrencyPrices from "../../../../hooks/currencyPrices/useCurrencyPrices";
import usePayments from "../../../../hooks/business/usePayments";
import useUser from '../../../../hooks/user/useUser';
import useBanks from "../../../../hooks/cards/useBanks";

// Service
import salesService from '../../../../services/salesService';
import { PaymentStates } from '../../../../models/PaymentStates';

const Summary = () => {
    const { classes } = useStyles();
    const navigate = useNavigate();
    const { Notify, variants } = useNotify();
    const { sale, update, existProcessedPayment } = useCart();
    const [sellerModalOpen, setSellerModalOpen] = useState(false);
    const [customerModalOpen, setCustomerModalOpen] = useState(false);
    const [shippingDataModalOpen, setShippingDataModalOpen] = useState(false);
    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [promotionModalOpen, setPromotionModalOpen] = useState(false);
    const [invoiceDataModalOpen, setInvoiceDataModalOpen] = useState(false);
    const [observationsDataModalOpen, setObservationsDataModalOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);

    const { business } = useUser();
    const { checks } = useChecks(business?.country);
    const { banks } = useBanks(business?.country);
    const { currencyPrices } = useCurrencyPrices(business?.defaultCurrency);
    const { paymentMethodsHook } = usePayments(business?.id, sale?.subChannel);

    const handleOk = () => {
        salesService.SaleCancelation(sale.orderId)
            .then(() => navigate(`/orders/detail/${sale.orderId}`))
            .catch(() => Notify('Ocurrio un problema al intentar cancelar la venta.', variants.ERROR))
            .finally(() => setConfirmOpen(false));
    }

    const handleClickCancelar = () => {
        setConfirmOpen(true)
    }

    return (
        <>
            {
                sellerModalOpen &&
                <SellerModal
                    open={sellerModalOpen}
                    onClose={() => setSellerModalOpen(false)}
                />
            }
            {
                customerModalOpen &&
                <CustomerModal
                    open={customerModalOpen}
                    onClose={() => setCustomerModalOpen(false)}
                />
            }
            {
                shippingDataModalOpen &&
                <ShippingDataModal
                    open={shippingDataModalOpen}
                    onClose={() => setShippingDataModalOpen(false)}
                />
            }
            {
                paymentModalOpen &&
                <PaymentMethodModal
                    order={sale}
                    onChange={update}
                    open={paymentModalOpen}
                    onClose={() => setPaymentModalOpen(false)}
                    isManual={false}
                    business={business}
                    checks={checks}
                    banks={banks}
                    currencyPrices={currencyPrices}
                    paymentMethodsHook={paymentMethodsHook}
                />
            }
            {
                promotionModalOpen &&
                <PromotionModal
                    open={promotionModalOpen}
                    onClose={() => setPromotionModalOpen(false)}
                />
            }
            {
                invoiceDataModalOpen &&
                <InvoiceData
                    open={invoiceDataModalOpen}
                    onClose={() => setInvoiceDataModalOpen(false)}
                />
            }
            {
                observationsDataModalOpen &&
                <ObservationsOrder
                    open={observationsDataModalOpen}
                    onClose={() => setObservationsDataModalOpen(false)}
                />
            }
            <Box className={classes.root}>
                <Grid container direction='column' spacing={1} style={{ maxWidth: '99%' }}>
                    <Grid size="grow">
                        <TitleSummary />
                    </Grid>
                    <Grid size="grow">
                        <SelectPanel
                            onSellerClick={() => setSellerModalOpen(true)}
                            onCustomerClick={() => setCustomerModalOpen(true)}
                            onShippingDataClick={() => setShippingDataModalOpen(true)}
                            onPaymentClick={() => setPaymentModalOpen(true)}
                            onPromotionClick={() => setPromotionModalOpen(true)}
                            onInvoiveClick={() => setInvoiceDataModalOpen(true)}
                            onObservationClick={() => setObservationsDataModalOpen(true)}
                        />
                    </Grid>
                    <Grid size="grow">
                        <ReturnMode disabled={existProcessedPayment} />
                    </Grid>
                    <Grid size="grow">
                        <PurchaseItems />
                    </Grid>
                    <Grid size="grow">
                        <Paper className={classes.paper}>
                            <Totals />
                        </Paper>
                    </Grid>
                    <Grid size="grow">
                        <InitiatePayment />
                    </Grid>
                    <Grid size="grow">
                        <Button
                            className={classes.btnCancel}
                            variant='contained'
                            color='primary'
                            disabled={sale.payments?.some(p => p.state === PaymentStates.Approved)}
                            onClick={handleClickCancelar}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <ModalConfirm
                title="Cancelar venta"
                message='¿Está seguro/a de cancelar la venta?'
                open={confirmOpen}
                onAccept={handleOk}
                onCancel={() => setConfirmOpen(false)}
                onClose={() => setConfirmOpen(false)}
            />
        </>
    );
}

export default Summary;